<template>
    <div  class="home">
        <div v-show="isMask" class="mask"></div>
        <!-- <div class="dialog-top" style="height:50px">
            <div class="left" >
                <span style="color:#cd1231;margin-left: -10px;">*</span>
                <span>城市</span>
            </div>
            <div class="right">
                <el-form :inline="true" :model="searchForm" ref="searchForm" class="searchForm">
                    <el-form-item class="item" prop="areaCode">
                        <el-select v-model="searchForm.areaCode" placeholder="请选择城市" size="small" style="width: 190px;" clearable>
                            <el-option v-for="(item) in areaCodearr" :key="item.orgCode" :label="item.orgName.split('|')[0]" :value="item.orgCode">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
            </div>
        </div> -->
        <div class="dialog-top">
                <div class="left">
                    <div style="display:flex">
                        <!-- <span style="color:#cd1231;margin-left: -10px;">*</span> -->
                        <!-- <div>ignite</div> -->
                        <div>售点查询</div>
                    </div>
                    <!-- <div>规则筛选</div> -->
                </div>
                <div class="right">
                    <el-form :inline="true" :model="searchForm" ref="searchForm" class="searchForm">
                        <!-- <el-form-item class="item" prop="igniteStatus" v-if=" selectOptions.igniteStatus.length > 0">
                            <el-select v-if="options"  v-model="searchForm.igniteStatus" placeholder="IGNITE状态" size="small" multiple collapse-tags clearable>
                                <el-option v-for="(item)  in selectOptions.igniteStatus"  :key="item.key" :label="item.value" :value="item.key">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item class="item" prop="igniteStatus" v-else>
                            <el-select v-model="searchForm.igniteStatus" placeholder="IGNITE状态" size="small" multiple collapse-tags clearable>
                                <el-option v-for="(key,value)  in options.igniteStatus"  :key="value" :label="key" :value="value">
                                </el-option>
                            </el-select>
                        </el-form-item> -->
                        <!-- <el-form-item class="item" prop="areaCode">
                            <el-select v-model="searchForm.areaCode" placeholder="请选择城市" size="small" style="width: 190px;" clearable>
                                <el-option v-for="(item) in areaCodearr" :key="item.orgCode" :label="item.orgName.split('|')[0]" :value="item.orgCode">
                                </el-option>
                            </el-select>
                        </el-form-item> -->
                        <!-- <el-form-item class="item" prop="tradeStatus" v-if=" selectOptions.openStatus.length > 0">
                            <el-select  v-model="searchForm.tradeStatus" placeholder="售点状态" size="small" multiple collapse-tags clearable>
                            <el-option v-for="(item)  in selectOptions.openStatus"  :key="item.key" :label="item.value" :value="item.key">
                            </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item class="item" prop="tradeStatus" v-else>
                            <el-select v-model="searchForm.tradeStatus" placeholder="售点状态" size="small" multiple collapse-tags clearable>
                            <el-option v-for="(key,value)  in options.openStatus"  :key="value" :label="key" :value="value">
                            </el-option>
                            </el-select>
                        </el-form-item>

                        <el-form-item class="item" prop="businessType"  v-if=" selectOptions.bizForm.length > 0">
                            <el-select v-model="searchForm.businessType" placeholder="业态" size="small" multiple collapse-tags clearable>
                            <el-option v-for="(item)  in selectOptions.bizForm"  :key="item.key" :label="item.value" :value="item.key">
                            </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item class="item" prop="businessType"  v-else>
                            <el-select v-model="searchForm.businessType"  placeholder="业态" size="small" multiple collapse-tags clearable>
                                <el-option v-for="(item)  in options.bizForm"  :key="item.key" :label="item.value" :value="item.key">
                                </el-option>
                            </el-select>
                        </el-form-item> -->

                        <!-- v-if=" searchForm.businessType.length > 0" -->
                        <!-- <el-form-item class="item" prop="childType">
                            <el-select v-model="searchForm.childType" placeholder="子业态" size="small" multiple collapse-tags clearable>
                            <el-option v-for="(item)  in childTypeoptions"  :key="item.key" :label="item.value" :value="item.key">
                            </el-option>
                            </el-select>
                        </el-form-item> -->

                        <!-- <el-form-item class="item" prop="level" v-if=" selectOptions.pocGrade.length > 0 ">
                            <el-select v-model="searchForm.level" placeholder="档次" size="small" multiple collapse-tags clearable>
                            <el-option v-for="(item) in selectOptions.pocGrade" :key="item.key" :label="item.value" :value="item.key">
                            </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item class="item" prop="level" v-else>
                            <el-select v-model="searchForm.level" placeholder="档次" size="small" multiple collapse-tags clearable>
                            <el-option v-for="(key,value) in options.pocGrade" :key="value" :label="key" :value="value">
                            </el-option>
                            </el-select>
                        </el-form-item> -->

                        <!-- <el-form-item class="item" prop="salePotential" v-if=" selectOptions.salesVolume.length > 0">
                            <el-select v-model="searchForm.salePotential" placeholder="销售潜力" size="small" multiple collapse-tags clearable>
                            <el-option v-for="(item)  in selectOptions.salesVolume"  :key="item.key" :label="item.value" :value="item.key">
                            </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item class="item" prop="salePotential" v-else>
                            <el-select v-model="searchForm.salePotential" placeholder="销售潜力" size="small" multiple collapse-tags clearable>
                            <el-option v-for="(key,value)  in options.salesVolume" :key="value" :label="key" :value="value">
                            </el-option>
                            </el-select>
                        </el-form-item> -->

                        <el-form-item class="item" prop="saleName">
                            <el-input style="width:190px;" v-model="searchForm.saleName" placeholder="输入售点名称" size="small" clearable>
                            </el-input>
                        </el-form-item>
                        <el-form-item class="item" prop="igniteId">
                            <el-input style="width:190px;" v-model="searchForm.igniteId" placeholder="输入abiOneId" size="small" clearable>
                            </el-input>
                        </el-form-item>
                        <el-form-item class="item" style="width:70px;">
                            <el-button type="primary" size="small" @click="clickQuery()">搜索</el-button>
                        </el-form-item>
                    </el-form>
                </div>
        </div>
        <div class="dialog-warn" v-if="tableData.length == 0 && !loading ">
            注：如无法找到售点，请确认售点所属区域/级别等信息是否匹配所选查询条件
        </div>
        <div class="dialog-form" v-loading='loading'>
            <el-table
                :data="tableData"
                ref="dataTable"
                tooltip-effect="dark"
                empty-text
                style="width: 100%"
                border
                show-header
                row-key="igniteId"
                @selection-change="handleSelectionChange">
                <!-- :selectable="judgeSelect" -->
                <el-table-column
                type="selection"
                :reserve-selection = true
                align="center"
                label='全选'
                width="55">
                </el-table-column>
                <el-table-column
                align="center"
                label="城市"
                show-overflow-tooltip
                >
                <template slot-scope="scope">{{getName(scope.row.areaName) }}</template>
                </el-table-column>
                <el-table-column
                align="center"
                label="abiOneId"
                >
                <template slot-scope="scope">{{ scope.row.igniteId }}</template>
                </el-table-column>
                <el-table-column
                align="center"
                label="abiOneId"
                >
                <template slot-scope="scope">{{ scope.row.igniteId }}</template>
                </el-table-column>
                <el-table-column
                align="center"
                label="售点名称"
                show-overflow-tooltip
                >
                <template slot-scope="scope">{{ scope.row.pocName }}</template>
                </el-table-column>
                <el-table-column
                align="center"
                label="售点联系人"
                show-overflow-tooltip
                >
                <template slot-scope="scope">{{ scope.row.contactPerson }}</template>
                </el-table-column>
                <el-table-column
                align="center"
                label="售点联系方式"
                show-overflow-tooltip>
                <template slot-scope="scope">{{ scope.row.contactPhone }}</template>
                </el-table-column>
                <el-table-column
                align="center"
                label="地址"
                show-overflow-tooltip>
                <template slot-scope="scope">{{ scope.row.pocAddress }}</template>
                </el-table-column>
                <el-table-column
                align="center"
                label="活动日期"
                width="190"
                v-if="!searchList.reviseObj"
                >
                <template slot-scope="scope">
                    <div v-if="!searchList.reviseObj">
                        <el-input   @click.native="showDatePicker(scope.row)" readonly v-model="scope.row.timeListStr" placeholder="选择一个或多个日期" size="small" clearable>
                        </el-input>
                        <DatePicker
                            :ref="`datePickerRef${scope.row.igniteId}`"
                            align="right"
                            style="width:0px;overflow: hidden;height:0"
                            :readonly="false"
                            :theme-start-time="themeBasic.themeStartTime"
                            :theme-end-time="themeBasic.themeEndTime"
                            @handleChangeDate="handleChangeDate"
                            />
                        <!-- <el-date-picker
                        style="width:160px;"
                        @change="timeChange(scope.row)"
                        type="dates"
                        value-format="yyyy-MM-dd"
                        v-model="scope.row.timeList"
                        :picker-options="pickerOptions(themeBasic)"
                        placeholder="选择一个或多个日期"
                        size="small"
                        clearable
                        :default-value="defauleTime"
                        >
                        </el-date-picker> -->
                    </div>
                    <!-- <div v-else>
                        <el-date-picker
                        style="width:160px;"
                        @change="timeChange(scope.row)"
                        type="dates"
                        value-format="yyyy-MM-dd"
                        v-model="scope.row.timeList"
                        :picker-options="pickerOptionschange(themeBasic)"
                        placeholder="选择一个或多个日期"
                        size="small"
                        clearable
                        :default-value="defauleTime"
                        >
                        </el-date-picker>
                    </div> -->
                </template>
                </el-table-column>
                <!-- <el-table-column
                align="center"
                label="操作"
                show-overflow-tooltip>
                <template slot-scope="scope">
                    <div style="display:flex;justify-content: center;">
                        <div style="color:#409EFF;cursor: pointer;" @click="handleChange(scope.row)">选择</div>
                        <div style="color: rgba(232, 232, 232);cursor: pointer;" @click="handleCancel(scope.row)">取消选择</div>
                    </div>
                </template>
                </el-table-column> -->
            </el-table>
        </div>
        <div class="dialog-bottom" v-if="tableData.length >0">
            <el-pagination
                background
                :total="searchForm.total"
                layout="total, prev, pager, next"
                :current-page="searchForm.page"
                :page-size="searchForm.pageSize"
                @current-change="handleCurrentChange">
                <span style="text-align: center">{{searchForm.page}}/{{allPage}}</span>
            </el-pagination>
        </div>
        <div class="dialog-close" @click="closeDialog()">
            <i class="el-icon-close" style="font-size: 28px;"></i>
        </div>
        <div class="dialog-btn">
                <div class="btn-left" @click="closeDialog()" >取消</div>
                <!-- <div class="btn-right" v-if="searchList.router == '06'" @click= 'clickOkupdate()'>确定</div>
                <div class="btn-right"  v-else @click= 'clickOk()'>确定</div> -->
                <div class="btn-right"  @click= 'clickOk()'>确定</div>
        </div>
        <div class="dialog-update" v-if="isShowupdate" >
            <el-table
            :data="updatedList"
            ref="updateTable"
            show-header
            class="update-table"
            style="width: 100%">
            <el-table-column
            prop="pocName"
            label="门店名称"
            align="center"
            width="90"
            show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
            label="门店联系人"
            align="center"
            >
            <template slot-scope="scope">
                <el-input class="item-input" size="mini" v-model="scope.row.contactPerson"  @change="changeInput" clearable>{{ scope.row.contactPerson }}</el-input>
            </template>
            </el-table-column>
            <el-table-column
            label="联系人手机号"
            align="center"
            >
            <template slot-scope="scope">
                <el-input  class="item-input" size="mini" v-model="scope.row.contactPhone"  @change="changeInput" clearable>{{ scope.row.contactPhone }}</el-input>
            </template>
            </el-table-column>
            <el-table-column
            label="百威联系人"
            align="center"
            >
            <template slot-scope="scope">
                <el-input  class="item-input" size="mini" v-model="scope.row.bwContactPerson"  @change="changeInput(scope.row)" clearable>{{ scope.row.bwContactPerson }}</el-input>
            </template>
            </el-table-column>
        </el-table>
        <div class="dialog-btn2">
            <div class="btn-left" @click="closeSure()" >取消</div>
            <div class="btn-right"  @click= 'updateSure()'>确定</div>
        </div>
        </div>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex'
    import gameplanApi from '../../../api/gameplan';
    import DatePicker from "../components/date-picker.vue";
    export default {
      name: 'activity-report-single-point',
      props: {
        options:{type:Object,default:()=>{}},
        searchList:{type:Object,default:()=>{}},
        // dataList:{type:object,default:()=>{}},
      },
      components: {
        DatePicker
      },
      data () {
        return {
            tableData: [],
            searchForm: {
                igniteStatus: [],
                tradeStatus: [],
                channel: [],
                businessType: [],
                level: [],
                salePotential: [],
                saleName: '',
                childType:[],
                pageSize:10,
                page:1,
                total:0,
                areaCode: '',
                igniteId:''
            },
            themeDetailId: '',
            selectOptions:[],
            isQueryfirst:false,
            multipleSelection:[],
            multipleSelectAll:[],
            multipleSelectionAgain:[],
            loading:true,
            allPage: 0,
            lastRouter:'',
            updatedList:[],
            isShowupdate: false,
            isMask:false,
            areaCodearr: [],
            themeBasic: this.searchList.themeBasic,
            defauleTime:'',
            pickerOptions(row = {}) {
                return{
                    disabledDate (time) {
                        return time.getTime() > row.themeEndTime ||  time.getTime() < row.themeStartTime
                    }
                }
            },
            pickerOptionschange(row = {}) {
                return{
                    disabledDate (time) {
                        return time.getTime() < Date.now() - 8.64e7 ||  time.getTime() > row.themeEndTime ||  time.getTime() < row.themeStartTime
                    }
                }
            },
            // childTypeoptions:{}
        }
      },
      computed: {
        ...mapGetters(['userInfo']),
        childTypeoptions () {
            let arr = []
            for (let item1 in this.options.subBizForm) {
                let obj = {}
                obj[item1] = this.options.subBizForm[item1]
                for (let item2 of this.searchForm.businessType) {
                    if ( item1.substr(0,10) == item2) {
                        arr.push({key:item1,value:obj[item1]})
                    }
                }
            }
            return arr
        }
      },
      watch: {},
      created () {
        this.themeDetailId = this.searchList.themeDetailId
        // this.defauleTime = new Date(this.searchList.themeBasic.themeStartTime);
        // this.defauleTime.setMonth(new Date(this.searchList.themeBasic.themeStartTime).getMonth());
        // if (this.searchList.igniteRuleObj.bizForm.length  ==  0) {
        //     if (this.searchList.themeCode.substr(0,2) == '01') {
        //         this.options.bizForm = [
        //             {'key':'2022010103','value':"大排档"},
        //             {'key':'2022010104','value':"火锅"},
        //             {'key':'2022010105','value':"烧烤/小龙虾"},
        //             {'key':'2022010106','value':"中式正餐"},
        //             {'key':'2022010201','value':"夜总会"},
        //             {'key':'2022010202','value':"KTV"},
        //             {'key':'2022010203','value':"慢摇吧"},
        //             {'key':'2022010204','value':"酒吧"},
        //             {'key':'2022010205','value':"餐吧"},
        //         ]
        //     }
        //     else if (this.searchList.themeCode.substr(0,2) == '02') {
        //         this.options.bizForm = [
        //             {'key':'2022010103','value':"大排档"},
        //             {'key':'2022010104','value':"火锅"},
        //             {'key':'2022010105','value':"烧烤/小龙虾"},
        //             {'key':'2022010106','value':"中式正餐"}
        //         ]
        //     }
        //     else if (this.searchList.themeCode.substr(0,2) == '03') {
        //         this.options.bizForm = [
        //             {'key':'2022010203','value':"慢摇吧"},
        //         ]
        //     }
        //     else if (this.searchList.themeCode.substr(0,2) == '04') {
        //         this.options.bizForm = [
        //             {'key':'2022010201','value':"夜总会"},
        //             {'key':'2022010202','value':"KTV"}
        //         ]
        //     }
        //     else if (this.searchList.themeCode.substr(0,2) == '05') {
        //         this.options.bizForm = [
        //             {'key':'2022010204','value':"酒吧"},
        //             {'key':'2022010205','value':"餐吧"}
        //         ]
        //     }
        //     else if (this.searchList.themeCode.substr(0,2) == '06') {
        //         this.options.bizForm = [
        //             {'key':'2022010204','value':"酒吧"},
        //             {'key':'2022010205','value':"餐吧"}
        //         ]
        //     }
        //     else if (this.searchList.themeCode.substr(0,2) == '07') {
        //         this.options.bizForm = [
        //             {'key':'2022010102','value':"外国餐厅"},
        //             {'key':'2022010204','value':"酒吧"},
        //             {'key':'2022010205','value':"餐吧"}
        //         ]
        //     }
        //     else if (this.searchList.themeCode.substr(0,2) == '08') {
        //         this.options.bizForm = [
        //             {'key':'2022010102','value':"外国餐厅"},
        //             {'key':'2022010204','value':"酒吧"},
        //             {'key':'2022010205','value':"餐吧"}
        //         ]
        //     }
        //     else if (this.searchList.themeCode.substr(0,2) == '09') {
        //         this.options.bizForm = [
        //             {'key':'2022010102','value':"外国餐厅"},
        //             {'key':'2022010204','value':"酒吧"},
        //             {'key':'2022010205','value':"餐吧"}
        //         ]
        //     }
        //     else {
        //         this.options.bizForm = []
        //     }
        // }
        // let arr1 = []
        // let arr2 = []
        // let arr3 = []
        // let arr4 = []
        // let arr5 = []
        // let arr6 = []
        // if (this.searchList.igniteRuleObj.igniteStatus.length > 0) {
        //     this.searchForm.igniteStatus = this.searchList.igniteRuleObj.igniteStatus
        // } else {
        //     this.searchForm.igniteStatus = arr1
        // }
        // if (this.searchList.igniteRuleObj.openStatus.length > 0) {
        //     this.searchForm.tradeStatus = this.searchList.igniteRuleObj.openStatus
        // } else {
        //     this.searchForm.tradeStatus = arr2
        // }
        // if (this.searchList.igniteRuleObj.bizForm.length > 0) {
        //     this.searchForm.businessType = this.searchList.igniteRuleObj.bizForm
        // } else {
        //     this.searchForm.businessType = arr4
        // }
        // if (this.searchList.igniteRuleObj.pocGrade.length > 0) {
        //     this.searchForm.level = this.searchList.igniteRuleObj.pocGrade
        // } else {
        //     this.searchForm.level = arr5
        // }
        // if (this.searchList.igniteRuleObj.salesVolume.length > 0) {
        //     this.searchForm.salePotential = this.searchList.igniteRuleObj.salesVolume
        // } else {
        //     this.searchForm.salePotential = arr6
        // }

        if (this.searchList.router) {
            this.lastRouter =  this.searchList.router
        }
        this.init()

        if (this.searchList.router !== '06') {
            if (this.searchList.singleData.length > 0) {
                let singleData = this.searchList.singleData
                this.multipleSelectionAgain = singleData
            }
        } else {
            this.multipleSelectionAgain =  this.searchList.reviseObj
        }
        console.log(this.searchList,'单售点-子组件-searchList');
      },
      mounted () {},
      updated () {},
      methods: {
        init () {
            // this.getSelectList()
            // this.getQueryarea()
            this.getSaleList()
        },
        getName(str){
            if(str){
                return str.split('|')[0] || str
            }else return ''
        },
        handleChangeDate(selectList,id,row){
            const itemList = this.tableData.filter(item=>{
                return item.igniteId == row.igniteId
            })
            if(itemList.length!==0){
              let dateList = selectList
              dateList = [...new Set(dateList)]
              dateList.sort((a, b) => {
                return new Date(a.replace(/-/g, '/')) <new Date(b.replace(/-/g, '/')) ? -1 : 1
                // return a < b ? -1 : 1
              })
              itemList[0].timeList = dateList
              itemList[0].timeListStr = dateList.join(',')
              this.$set(itemList[0],'timeListStr', dateList.join(','))
            }
          this.timeChange(itemList[0])
        },
        showDatePicker(row){
            const newDateList = row.timeList.map(item=>{
              const date = new Date(item.replace(/-/g, '/'))
              return date.getTime()
            })
          this.$refs[`datePickerRef${row.igniteId}`].showDatePicker(newDateList,row)
        },
        timeChange (timeItem){
            // console.log(timeItem,'timeItem');
            if (this.searchList.needTransitions == 0 && !this.searchList.reviseObj) {
                if (this.searchList.perExecDays) {
                    if (timeItem.timeList !== null && timeItem.timeList.length !== this.searchList.perExecDays) {
                        this.$message.error(`选择日期天数应与执行天数相等,当前已选 ${timeItem.timeList.length}天，应选 ${this.searchList.perExecDays}天`)
                        // return
                    }
                } else {
                    // this.$message.warning('配置天数未返回')
                }
            }
            this.$refs[`datePickerRef${timeItem.igniteId}`].hideDatePicker()
        },
        async getQueryarea () {
            let params = {
                'regionCode':this.searchList.regionCode
            }
           let res = await gameplanApi.getQueryarea(params)
           if (res.data.resultCode == '0') {
            this.areaCodearr = res.data.resultData.regionList
            if (this.searchList.reviseObj) {
                this.searchForm.areaCode = this.searchList.reviseObj[0].areaCode
            } else {
                // this.searchForm.areaCode = this.areaCodearr[0].orgCode
            }
            this.getSaleList()
           }
        },
        getSelectList () {
            let igniteStatus = {}
            let arr1 =[]
            let arr2 =[]
            let arr3 =[]
            let arr4 =[]
            let arr5 =[]
            let arr6 =[]
            for (let item1 in this.options.igniteStatus) {
                let obj = {}
                obj[item1] = this.options.igniteStatus[item1]
                for (let item2 of this.searchList.igniteRuleObj.igniteStatus) {
                    if (item1 == item2) {
                        arr1.push({key:item1,value:obj[item1]})
                    }
                }
            }
            for (let item1 in this.options.openStatus) {
                let obj = {}
                obj[item1] = this.options.openStatus[item1]
                for (let item2 of this.searchList.igniteRuleObj.openStatus) {
                    if (item1 == item2) {
                        arr2.push({key:item1,value:obj[item1]})
                    }
                }
            }
            for (let item1 in this.options.channel) {
                let obj = {}
                obj[item1] = this.options.channel[item1]
                for (let item2 of this.searchList.igniteRuleObj.channel) {
                    if (item1 == item2) {
                        arr3.push({key:item1,value:obj[item1]})
                    }
                }
            }
            for (let item1 in this.options.bizForm) {
                let obj = {}
                obj[item1] = this.options.bizForm[item1]
                for (let item2 of this.searchList.igniteRuleObj.bizForm) {
                    if (item1 == item2) {
                        arr4.push({key:item1,value:obj[item1]})
                    }
                }
            }
            for (let item1 in this.options.pocGrade) {
                let obj = {}
                obj[item1] = this.options.pocGrade[item1]
                for (let item2 of this.searchList.igniteRuleObj.pocGrade) {
                    if (item1 == item2) {
                        arr5.push({key:item1,value:obj[item1]})
                    }
                }
            }
            for (let item1 in this.options.salesVolume) {
                let obj = {}
                obj[item1] = this.options.salesVolume[item1]
                for (let item2 of this.searchList.igniteRuleObj.salesVolume) {
                    if (item1 == item2) {
                        arr6.push({key:item1,value:obj[item1]})
                        // arr6.push(this.options.salesVolume[item1])
                    }
                }

            }
            this.selectOptions.igniteStatus= arr1
            this.selectOptions.openStatus= arr2
            this.selectOptions.channel= arr3
            this.selectOptions.bizForm= arr4
            this.selectOptions.pocGrade= arr5
            this.selectOptions.salesVolume= arr6
        },
        getSaleList () {
            let params = {
                'page':this.searchForm.page,
                'pageSize':this.searchForm.pageSize,
                'themeDetailId':this.themeDetailId,
                // // 'igniteStatus':this.searchForm.igniteStatus.join(','),
                // 'openStatus':this.searchForm.tradeStatus.join(','),
                // 'channel':this.searchForm.channel.join(','),
                // 'bizForm':this.searchForm.businessType.join(','),
                // 'pocGrade':this.searchForm.level.join(','),
                // // 'salesVolume':this.searchForm.salePotential.join(','),
                // 'subBizForm':this.searchForm.childType.join(','),
                'pocSelfDefinedName':this.searchForm.saleName,
                // 'areaCode':this.searchForm.areaCode,
                'regionCode':this.searchList.regionCode,
                'igniteId':this.searchForm.igniteId
            }
            this.loading = true
            gameplanApi.getGamepalnSalequery(params).then((res)=>{
                if (res.data.resultCode == '0') {
                    this.loading = false
                    let pageInfo = res.data.resultData.pageInfo
                    let tableData = res.data.resultData.pocList
                    // this.allPage = Math.ceil(this.searchForm.total/ this.searchForm.pageSize)
                    this.searchForm.total = pageInfo.totalCounts
                    this.allPage = pageInfo.totalPages
                    for (let item of tableData) {
                        item.timeList = []
                        item.timeListStr = ''
                        if (this.multipleSelection.length > 0) {
                            for (let item2 of this.multipleSelection) {
                                if (item.igniteId == item2.igniteId) {
                                    item.timeList =  item2.timeList
                                    item.timeListStr = item2.timeList.join(',')
                                }
                            }
                        }
                    }
                    this.tableData = tableData
                    if (this.multipleSelection.length > 0 ) {
                        this.$nextTick(()=>{
                            let arr = []
                            let arrTime = []
                            for (let item of this.multipleSelection) {
                                arr.push(item.igniteId)
                                arrTime.push({
                                    'igniteId':item.igniteId,
                                    'timeList':item.timeList,
                                })
                            }
                            for (let item1 of this.tableData) {
                                item1.timeListStr = ''
                                for (let item2 of arrTime) {
                                    if (item1.igniteId == item2.igniteId) {
                                        if (item2.timeList) {
                                            item1.timeList = item2.timeList
                                            item1.timeListStr = item2.timeList.join(',')
                                        }
                                    }
                                }
                            }
                            this.tableData.forEach(row => {
                                if(arr.indexOf(row.igniteId) >= 0 ){
                                    this.$refs.dataTable.toggleRowSelection(row,true);
                                }
                            })
                        })
                    }
                    if (this.multipleSelectionAgain.length > 0 ) {
                        this.$nextTick(()=>{
                            let multipleSelectionAgain = this.multipleSelectionAgain
                            let arr = []
                            let arrTime = []
                            for (let item of multipleSelectionAgain) {
                                arr.push(item.igniteId)
                                arrTime.push({
                                    'igniteId':item.igniteId,
                                    'timeList':item.timeList
                                })
                            }
                            for (let item1 of this.tableData) {
                                for (let item2 of arrTime) {
                                    if (item1.igniteId == item2.igniteId) {
                                        if (item2.timeList) {
                                            item1.timeList = item2.timeList
                                            item1.timeListStr = item2.timeList.join(',')
                                        }
                                    }
                                }
                            }
                            this.tableData.forEach(row => {
                                if(arr.indexOf(row.igniteId) >= 0){
                                    this.$refs.dataTable.toggleRowSelection(row,true);
                                }
                            })
                        })
                    }
                } else {
                    this.loading = false
                }
            })
        },
        clickQuery() {
            this.searchForm.page = 1
            this.getSaleList()
        },
        // 页码
        handleCurrentChange (val) {
            this.searchForm.page = val
            this.getSaleList()
        },
        closeDialog () {
            this.$emit('closeMask')
        },
        clickOk () {
            if (this.lastRouter == '06') {
                if (this.multipleSelection.length > 1) {
                    this.$message.warning('修改单售点只能选择一项')
                    return
                }
            }
            if (this.multipleSelection.length < 1) {
                this.$message.warning('单售点最少选择一项')
                return
            }
            if (!this.searchList.reviseObj) {
                if (this.searchList.needTransitions == 0 ) {
                    if (this.searchList.perExecDays) {
                        for (let i = 0; i < this.multipleSelection.length; i++) {
                        if (this.multipleSelection[i].timeList !== null && this.multipleSelection[i].timeList.length !== this.searchList.perExecDays) {
                            this.$message.warning(`“${this.multipleSelection[i].pocName}” 售点活动日期天数与配置活动执行天数不符，已选择${this.multipleSelection[i].timeList.length}天，应选择${this.searchList.perExecDays}天`)
                            return
                        }
                        if (this.multipleSelection[i].timeList == null){
                            this.$message.warning(`“${this.multipleSelection[i].pocName}” 售点活动日期天数与配置活动执行天数不符，已选择0天，应选择${this.searchList.perExecDays}天`)
                            return
                        }
                    }
                    } else {
                        // this.$message.warning('配置天数未返回')
                    }

                } else {
                    for (let i = 0; i < this.multipleSelection.length; i++) {
                        if (this.multipleSelection[i].timeList !== null && this.multipleSelection[i].timeList.length == 0) {
                            this.$message.warning(`请选择 “${this.multipleSelection[i].pocName}” 售点活动日期天数`)
                            return
                        }
                        if (this.multipleSelection[i].timeList == null) {
                            this.$message.warning(`请选择 “${this.multipleSelection[i].pocName}” 售点活动日期天数`)
                            return
                        }
                    }
                }

            }
            for (let item of this.multipleSelection) {
                item.regionCode = this.searchList.regionCode
                if (this.searchList.reviseObj) {
                    item.timeList = this.searchList.reviseObj[0].timeList
                }
            }
            let number = this.addNumber(this.multipleSelection)
            if (number > this.searchList.noAddnumber) {
                this.$message.warning('添加场次超出未提报场次')
                return
            }
            if (!this.searchList.activityReturn) {
                this.$emit("handleChange",this.multipleSelection)
            } else {
                this.$emit("handleChangereturn",this.multipleSelection)
            }
            this.$emit('closeMask')
        },
        handleSelectionChange (val) {
            // console.log(val,'handleSelectionChange');
            this.multipleSelection = val
        },
        // judgeSelect (row,index) {
        //     if (this.searchList.previousPage) {
        //         if (this.multipleSelectionAgain.some(item => item.igniteId === row.igniteId)) {
        //             return false
        //         } else {
        //             return true// 不禁用
        //         }
        //     } else {
        //         return true// 不禁用
        //     }
        // },
        handleChange (row) {
            // console.log(row,'handleChange-son');
            this.$emit("handleChange",row)
        },
        handleCancel (row) {
        },
        changeInput (row) {
        },
        clickOkupdate () {
            if (this.multipleSelection.length > 1) {
                this.$message.warning('修改单售点只能选择一项')
            } else {
                this.updatedList = this.multipleSelection
                this.isMask = true
                this.isShowupdate = true
            }
        },
        updateSure () {
            console.log("handleChange",this.updatedList);
            this.isMask = false
            this.isShowupdate = false
            this.$emit("handleChange",this.updatedList)
            this.$emit('closeMask')
        },
        closeSure () {
            this.isMask = false
            this.isShowupdate = false
        },
         // 已添加
         addNumber (arr) {
            let allNum = 0
            if (this.searchList.needTransitions == 0) {
                allNum = arr.length
                // console.log(allNum,'allNum--0000');
                return allNum
            }
            else if (this.searchList.needTransitions == 1) {
                for (let item of arr) {
                    allNum = allNum + item.timeList.length
                }
                // console.log(allNum,'allNum--1111');
                return allNum
            }

        }
    }
}
</script>
<style lang="scss" scoped>
    .home {
        position: relative;
        .dialog-top {
            display: flex;
            // height: 100px;
            color: #101010;
            // line-height: 50px;
            .left {
                width: 80px;
                line-height: 40px;
                font-size: 16px;
                text-align: left;
                font-weight: bold;
                margin-right: 10px;
            }
            .right {
                flex: 1;
                .searchForm {
                    width: 100%;
                    .item {
                        width: 190px;
                        line-height: 40px;
                        margin: 0px 10px 0px 0px;
                    }
                }
            }
        }
        .dialog-warn {
            line-height: 30px;
            height: 30px;
            font-size: 12px;
            color: #cd1231;
        }
        .dialog-form {
            margin-bottom: 20px;
            overflow: hidden;
            overflow-y:scroll;
            // height: 300px;
            max-height: 50vh;
            ::v-deep .el-table th.el-table__cell {
                color: #101010;
                background-color: rgba(232, 232, 232);
            }
            ::v-deep .el-table__body tr.current-row>td.el-table__cell {
                background-color: #FFFFFF !important;
            }
            ::v-deep .el-table--enable-row-hover .el-table__body tr:hover > td {
                background-color: #FFFFFF !important;
            }
        }
        .dialog-bottom {
            position: relative;
            bottom: 0;
            text-align: center;
            // ::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
            //     background-color: #fff;
            //     color: #409EFF;
            //     border: 1px solid #409EFF
            // }
            // ::v-deep .el-pagination.is-background .el-pager li:hover {
            //     color: #409EFF;
            // }
            ::v-deep .el-pagination.is-background .btn-next,
            ::v-deep .el-pagination.is-background .btn-prev{
                background-color: #FFFFFF;
                color: #000;
                // width: 66px;
                // height: 33px;
                // line-height: 33px;
                border: 1px solid #C0C4CC;
                border-radius: 3px;
            }
            ::v-deep .el-pagination.is-background .btn-next:disabled,
            ::v-deep .el-pagination.is-background .btn-prev:disabled,
            ::v-deep .el-pagination.is-background .el-pager li.disabled {
                color: #C0C4CC;
            }
        }
        .dialog-close {
            width: 30px;
            height: 30px;
            position: absolute;
            top: 0px;
            right: 10px;
            cursor: pointer;
        }
        .dialog-btn {
            position: relative;
            bottom: 0;
            height: 30px;
            line-height: 30px;
            display: flex;
            justify-content:flex-end;
            .btn-left {
                width: 80px;
                text-align: center;
                background-color: #FFFFFF;
                color: #cd1231;
                border-radius: 5px;
                border: 1px solid #cd1231;
                margin-right: 10px;
                cursor: pointer;
            }
            .btn-right {
                width: 80px;
                text-align: center;
                background-color: #cd1231;
                color: #FFFFFF;
                border-radius: 5px;
                border: 1px solid #cd1231;
                cursor: pointer;
            }
        }

        .mask{
            position: fixed;
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
            background: rgba(0,0,0,.7) ;
            z-index: 3;
        }
        .dialog-update{
            position: absolute;
            border-radius: 8px;
            width: 90%;
            top: 10%;
            left: 5%;
            // height: 100px;
            max-height: 200px;
            padding: 10px;
            background-color: #FFFFFF;
            z-index: 5;
            ::v-deep .el-table th.el-table__cell {
                color: #101010;
                background-color: rgba(232, 232, 232);
            }
            ::v-deep .el-table__body tr.current-row>td.el-table__cell {
                background-color: #FFFFFF !important;
            }
            ::v-deep .el-table--enable-row-hover .el-table__body tr:hover > td {
                background-color: #FFFFFF !important;
            }
            .update-table{
                width: 80%;
                // padding: 10px;
                border-radius: 8px;
                .item-input {
                    width: 140px;
                }
            }

            .dialog-btn2 {
                margin-top: 10px;
                height: 30px;
                line-height: 30px;
                display: flex;
                justify-content:flex-end;
                .btn-left {
                    width: 80px;
                    text-align: center;
                    background-color: #FFFFFF;
                    color: #cd1231;
                    border-radius: 5px;
                    border: 1px solid #cd1231;
                    margin-right: 10px;
                    cursor: pointer;
                }
                .btn-right {
                    width: 80px;
                    text-align: center;
                    background-color: #cd1231;
                    color: #FFFFFF;
                    border-radius: 5px;
                    border: 1px solid #cd1231;
                    cursor: pointer;
                }
        }

        }
    }
</style>
